
import { useState, useRef, useCallback, useEffect, ClipboardEvent, KeyboardEvent } from 'react';
import { ShieldCheck, RotateCcw, ArrowRight, CheckCircle2 } from 'lucide-react';

// const DIGIT_REGEX = /^\d$/;
 
// function maskEmail(email: string): string {
//   const [local, domain] = email.split('@');
//   if (!domain) return email;
//   const visible = local.slice(0, 2);
//   const masked = '*'.repeat(Math.max(local.length - 2, 3));
//   return `${visible}${masked}@${domain}`;
// }
// export interface OtpInputProps {
//     length: number;
//     value: string[];
//     onChange: (value: string[]) => void;
//     hasError: boolean;
//     disabled: boolean;
//   }

// export const OtpInput = ({ length, value, onChange, hasError, disabled }: OtpInputProps) => {
//     const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
   
//     const focusAt = useCallback((index: number) => {
//       inputRefs.current[Math.max(0, Math.min(index, length - 1))]?.focus();
//     }, [length]);
   
//     const handleChange = useCallback((index: number, char: string) => {
//       if (!DIGIT_REGEX.test(char)) return;
//       const next = [...value];
//       next[index] = char;
//       onChange(next);
//       if (index < length - 1) focusAt(index + 1);
//     }, [value, onChange, length, focusAt]);
   
//     const handleKeyDown = useCallback((index: number, e: KeyboardEvent<HTMLInputElement>) => {
//       if (e.key === 'Backspace') {
//         e.preventDefault();
//         const next = [...value];
//         if (next[index]) {
//           next[index] = '';
//           onChange(next);
//         } else if (index > 0) {
//           next[index - 1] = '';
//           onChange(next);
//           focusAt(index - 1);
//         }
//       } else if (e.key === 'ArrowLeft') {
//         e.preventDefault();
//         focusAt(index - 1);
//       } else if (e.key === 'ArrowRight') {
//         e.preventDefault();
//         focusAt(index + 1);
//       } else if (e.key === 'Home') {
//         e.preventDefault();
//         focusAt(0);
//       } else if (e.key === 'End') {
//         e.preventDefault();
//         focusAt(length - 1);
//       }
//     }, [value, onChange, focusAt, length]);
   
//     const handlePaste = useCallback((e: ClipboardEvent<HTMLInputElement>) => {
//       e.preventDefault();
//       const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
//       if (!pasted) return;
//       const next = Array(length).fill('');
//       pasted.split('').forEach((ch, i) => { next[i] = ch; });
//       onChange(next);
//       focusAt(Math.min(pasted.length, length - 1));
//     }, [length, onChange, focusAt]);
   
//     // Split slots into two groups of 3 for visual grouping
//     const midpoint = Math.floor(length / 2);
   
//     const renderSlots = (indices: number[]) =>
//       indices.map((i) => (
//         <input
//           key={i}
//           ref={(el) => { inputRefs.current[i] = el; }}
//           type="text"
//           inputMode="numeric"
//           pattern="\d*"
//           maxLength={1}
//           value={value[i] ?? ''}
//           disabled={disabled}
//           aria-label={`Digit ${i + 1} of ${length}`}
//           onChange={(e) => handleChange(i, e.target.value)}
//           onKeyDown={(e) => handleKeyDown(i, e)}
//           onPaste={handlePaste}
//           onFocus={(e) => e.target.select()}
//           className={[
//             // Base
//             'w-12 h-14 text-center text-xl font-bold rounded-xl border-2 outline-none',
//             'transition-all duration-150 select-none',
//             // Font & colour
//             'font-mono text-gray-900',
//             // States
//             disabled
//               ? 'bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed'
//               : hasError
//               ? 'border-red-400 bg-red-50 text-red-700 focus:border-red-500 focus:ring-2 focus:ring-red-200'
//               : value[i]
//               ? 'border-primary-500 bg-primary-50 text-primary-700 focus:border-primary-600 focus:ring-2 focus:ring-primary-200'
//               : 'border-gray-200 bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-100',
//           ].join(' ')}
//         />
//       ));
   
//     return (
//       <div className="flex items-center justify-center gap-2" role="group" aria-label="OTP input">
//         <div className="flex gap-2">{renderSlots(Array.from({ length: midpoint }, (_, i) => i))}</div>
//         {/* Separator dot */}
//         <span className="w-2 text-center text-gray-300 text-lg font-bold select-none">·</span>
//         <div className="flex gap-2">{renderSlots(Array.from({ length: length - midpoint }, (_, i) => i + midpoint))}</div>
//       </div>
//     );
//   };
type OtpInputState = 'idle' | 'error';
 
 
const OTP_LENGTH    = 6;
 
 
interface OtpInputProps {
  value: string[];
  onChange: (value: string[]) => void;
  inputState: OtpInputState;
  disabled: boolean;
}
 
const DIGIT_RE = /^\d$/;
 
export const OtpInput = ({ value, onChange, inputState, disabled }: OtpInputProps) => {
  const refs = useRef<(HTMLInputElement | null)[]>([]);
 
  const focus = (i: number) =>
    refs.current[Math.max(0, Math.min(i, OTP_LENGTH - 1))]?.focus();
 
  const handleChange = (i: number, char: string) => {
    if (!DIGIT_RE.test(char)) return;
    const next = [...value];
    next[i] = char;
    onChange(next);
    if (i < OTP_LENGTH - 1) focus(i + 1);
  };
 
  const handleKeyDown = (i: number, e: KeyboardEvent<HTMLInputElement>) => {
    switch (e.key) {
      case 'Backspace': {
        e.preventDefault();
        const next = [...value];
        if (next[i]) { next[i] = ''; onChange(next); }
        else if (i > 0) { next[i - 1] = ''; onChange(next); focus(i - 1); }
        break;
      }
      case 'ArrowLeft':  e.preventDefault(); focus(i - 1);        break;
      case 'ArrowRight': e.preventDefault(); focus(i + 1);        break;
      case 'Home':       e.preventDefault(); focus(0);            break;
      case 'End':        e.preventDefault(); focus(OTP_LENGTH - 1); break;
    }
  };
 
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH);
    if (!pasted) return;
    const next = Array(OTP_LENGTH).fill('');
    pasted.split('').forEach((ch, i) => { next[i] = ch; });
    onChange(next);
    focus(Math.min(pasted.length, OTP_LENGTH - 1));
  };
 
  const mid = Math.floor(OTP_LENGTH / 2);
 
  const renderGroup = (indices: number[]) =>
    indices.map((i) => (
      <input
        key={i}
        ref={(el) => { refs.current[i] = el; }}
        type="text"
        inputMode="numeric"
        pattern="\d*"
        maxLength={1}
        value={value[i] ?? ''}
        disabled={disabled}
        aria-label={`Digit ${i + 1} of ${OTP_LENGTH}`}
        onChange={(e) => handleChange(i, e.target.value)}
        onKeyDown={(e) => handleKeyDown(i, e)}
        onPaste={handlePaste}
        onFocus={(e) => e.target.select()}
        className={[
          'w-12 h-14 text-center text-xl font-bold font-mono rounded-xl border-2',
          'outline-none transition-all duration-150 select-none',
          disabled
            ? 'bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed'
            : inputState === 'error'
            ? 'border-red-400 bg-red-50 text-red-700 focus:border-red-500 focus:ring-2 focus:ring-red-200'
            : value[i]
            ? 'border-primary-500 bg-primary-50 text-primary-700 focus:border-primary-600 focus:ring-2 focus:ring-primary-200'
            : 'border-gray-200 bg-white text-gray-900 focus:border-primary-500 focus:ring-2 focus:ring-primary-100',
        ].join(' ')}
      />
    ));
 
  return (
    <div className="flex items-center justify-center gap-2" role="group" aria-label="OTP input">
      <div className="flex gap-2">{renderGroup(Array.from({ length: mid }, (_, i) => i))}</div>
      <span className="text-gray-300 text-xl font-bold select-none pb-0.5">·</span>
      <div className="flex gap-2">{renderGroup(Array.from({ length: OTP_LENGTH - mid }, (_, i) => i + mid))}</div>
    </div>
  );
};